import type { EmployeeEmergencyContactDto } from "@/generated/model/employeeEmergencyContactDto";
import { useProfileSectionEditing } from "@/hooks/use-profile-section-form";
import { textOrNotRecorded } from "@/lib/people";

import { EditEmergencyContactForm } from "../forms/EditEmergencyContactForm";
import { ProfileSectionCard } from "../ProfileSectionCard";
import { ProfileSectionEditButton } from "../ProfileSectionEditButton";

interface EmergencyContactSectionProps {
  nurseryId: string;
  userId: string;
  emergencyContact: EmployeeEmergencyContactDto;
  canEdit: boolean;
}

export function EmergencyContactSection({
  nurseryId,
  userId,
  emergencyContact,
  canEdit,
}: EmergencyContactSectionProps) {
  const { editing, editButtonRef, startEditing, stopEditing } =
    useProfileSectionEditing();

  return (
    <ProfileSectionCard
      title="Emergency contact"
      testId="profile-section-emergency-contact"
      action={
        canEdit &&
        !editing && (
          <ProfileSectionEditButton
            ref={editButtonRef}
            section="emergency contact"
            onClick={startEditing}
          />
        )
      }
      editForm={
        canEdit &&
        editing && (
          <EditEmergencyContactForm
            nurseryId={nurseryId}
            userId={userId}
            emergencyContact={emergencyContact}
            onDone={stopEditing}
          />
        )
      }
      fields={[
        { label: "Name", value: textOrNotRecorded(emergencyContact.name) },
        {
          label: "Relationship",
          value: textOrNotRecorded(emergencyContact.relationship),
        },
        { label: "Mobile", value: textOrNotRecorded(emergencyContact.mobile) },
        {
          label: "Alternative number",
          value: textOrNotRecorded(emergencyContact.alternativeNumber),
        },
        {
          label: "Home address",
          value: textOrNotRecorded(emergencyContact.homeAddress),
        },
      ]}
    />
  );
}
